import React, { Component } from 'react'
import ButtonLoader from './btnloader';
import { master_api, apiInstance } from "../actions/http"

class GetMaster extends Component {

    state = {
        fetching: false,
        data: null,
        error: false
    };

    componentDidMount(){
        this.getData();
    }

    async getData(){
        this.setState({fetching: true})
        try {
            let res = await apiInstance({
                url: master_api + this.props.id + "/",
                method: "GET"
            })
            this.setState({fetching: false, data: res.data})
        } catch(err){
            this.setState({fetching: false})
        }
    } 

    render() {
        let {fetching, error, data} = this.state;
        if (error) return null;
        if(fetching){
            return (
                <div className="flex-center" style={{height: `100px`}}>
                    <ButtonLoader />
                </div>
            )
        }
        if(data){
            return <div dangerouslySetInnerHTML={{__html: data.descriptions}} />;
        }
        return null;
    }
}

export default GetMaster